import type { PlanEntitlements, SessionPlan } from "@models/session";

/** A plan feature that gates a screen (see `PlanEntitlements`). */
export type PlanFeature = "stockManagement" | "monthlyReports" | "weeklyReports";

/** The server's own feature names (`error.details.feature`) mapped to ours. */
export const FEATURE_FROM_SERVER: Record<string, PlanFeature> = {
    stock_management: "stockManagement",
    monthly_reports: "monthlyReports",
    weekly_reports: "weeklyReports",
};

/**
 * Whether the plan includes a feature. Plans made before entitlements existed carry none, so —
 * like the server — they fall back to the plan key: only "starter" lacks the gated features.
 */
export function planAllows(plan: SessionPlan | null | undefined, feature?: PlanFeature): boolean {
    if (!feature) return true;
    if (!plan) return true;
    if (plan.entitlements) return plan.entitlements[feature] === true;
    return plan.key !== "starter";
}

export type UsageKey = "riders" | "customers" | "products";

/** The plan's cap for a resource; null means unlimited. */
export function planLimit(plan: SessionPlan | null | undefined, key: UsageKey): number | null {
    const e: PlanEntitlements | null | undefined = plan?.entitlements;
    if (!e) return null;
    switch (key) {
        case "riders":
            return e.maxRiders;
        case "customers":
            return e.maxCustomers;
        case "products":
            return e.maxProducts;
    }
}
